import { type VariantInfoValueStatus } from '../types/VariantInfoValueStatus';

export const VariantInfoValueStatuses: Record<VariantInfoValueStatus, VariantInfoValueStatus> = {
    UNAVAILABLE: 'UNAVAILABLE',
    AVAILABLE: 'AVAILABLE',
    PARTIALLY_AVAILABLE: 'PARTIALLY_AVAILABLE',
} as const;
